import { Dropdown, Icon } from 'light-component';
import { useTranslation } from '../../../i18n';
import type { ReactElement } from 'react';
import type { ConditionItem } from '../types';

interface ValueComponentProps {
  conditionItem: ConditionItem;
  width: number;
  item?: {
    value: string;
    title: string;
    type: string;
    options: { value: string; title: string }[];
  };
  onChange: (value: ConditionItem) => void;
}

export function ValueComponent({ conditionItem, width, item, onChange }: ValueComponentProps): ReactElement {
  const [t] = useTranslation();
  const hasDisabled = conditionItem.condition === 'empty' || conditionItem.condition === 'notEmpty';

  if (hasDisabled) {
    return (
      <input
        type='text'
        style={{ width }}
        value={conditionItem.condition === 'empty' ? t('空') : t('非空')}
        disabled
      />
    );
  }

  if (item == null) {
    return (
      <input
        type='text'
        placeholder={t('请输入')}
        style={{ width }}
        value={conditionItem.value}
        onChange={event => onChange({ ...conditionItem, value: event.target.value })}
      />
    );
  }

  if (item.type === 'RadioBox' || item.type === 'CheckBox') {
    return (
      <Dropdown
        value={conditionItem.value}
        placeholder={t('请选择选项')}
        icon={<Icon name='Down' />}
        options={item.options}
        placement='bottomLeft'
        origin='grid'
        onSelect={value => onChange({ ...conditionItem, value })}
      />
    );
  }

  if (item.type === 'Number' || item.type === 'ShotEyesStar') {
    return (
      <input
        type='number'
        placeholder={t('请输入')}
        style={{ width }}
        value={conditionItem.value}
        onChange={event => onChange({ ...conditionItem, value: event.target.value })}
      />
    );
  }

  return (
    <input
      type='text'
      placeholder={t('请输入')}
      style={{ width }}
      value={conditionItem.value}
      onChange={event => onChange({ ...conditionItem, value: event.target.value })}
    />
  );
}
